export enum ORDER {
    Newest = "newest",
    Oldest = "oldest",
    Specific = "specific"
}
